// import { StateListType } from './../../../types/state-list-type';
import { IReduxAction } from '../../../services/interfaces/common-interface';
import {
  SET_LOADING_DATA,
  SET_LOADING_SEND,
  GET_ALL_SUCCESS,
  GET_BY_ID_SUCCESS,
  SET_PAGE,
  SET_ROWS_PER_PAGE,
  SET_ORDER,
  SET_ORDERBY,
  SEARCH,
  GET_FILTER_SUCCESS
} from './client-constants';

const INITIAL_STATE: any = {
  loadingData: false,
  loadingSend: false,
  form: {
    data: null,
    errors: [],
    selects: null
  },
  list: {
    hasRemotePagination: true,
    allRows: [],
    rows: [],
    rowsCount: 0,
    page: 0,
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 25, 50, 100],
    selected: [],
    selectedCount: 0,
    order: 'asc',
    orderBy: 'name',
    skip: 0,
    limit: 10,
    hasMore: true
  }
};

const loadTypeReducer = (state: any = { ...INITIAL_STATE }, action: IReduxAction) => {
  switch (action.type) {
    case SET_LOADING_DATA: {
      return {
        ...state,
        loadingData: action.loading
      };
    }

    case SET_LOADING_SEND: {
      return {
        ...state,
        loadingSend: action.loading
      };
    }

    case GET_ALL_SUCCESS: {
      const { data, rowsCount } = action.payload;

      return {
        ...state,
        list: {
          ...state.list,
          rowsCount: rowsCount ?? 0,
          rows: data,
          allRows: data
        }
      };
    }

    case GET_FILTER_SUCCESS: {
      return {
        ...state,
        list: {
          ...state.list,
          rows: action.clients,
          allRows: action.clients,
          skip: action?.skip,
          limit: action?.limit,
          hasMore: action?.hasMore
        }
      };
    }

    case SEARCH: {
      const { queryText } = action;
      const results =
        queryText !== ''
          ? state.list.allRows.filter(
              (item: any) =>
                item?.clientName?.toLowerCase().startsWith(queryText.toLowerCase()) ||
                item?.clientName?.toLowerCase().includes(queryText.toLowerCase()) ||
                item?.name?.toLowerCase().startsWith(queryText.toLowerCase()) ||
                item?.name?.toLowerCase().includes(queryText.toLowerCase()) ||
                item?.externalCode?.toString() === queryText ||
                item?.governmentalCode?.toString().startsWith(queryText)
            )
          : state.list.allRows;

      return {
        ...state,
        list: {
          ...state.list,
          rows: [...results],
          queryText
        }
      };
    }

    case GET_BY_ID_SUCCESS: {
      return {
        ...state,
        form: {
          ...action.payload
        }
      };
    }

    case SET_PAGE: {
      return {
        ...state,
        list: {
          ...state.list,
          page: action.page
        }
      };
    }

    case SET_ROWS_PER_PAGE: {
      return {
        ...state,
        list: {
          ...state.list,
          rowsPerPage: action.rowsPerPage
        }
      };
    }

    case SET_ORDER: {
      return {
        ...state,
        list: {
          ...state.list,
          order: action.order
        }
      };
    }

    case SET_ORDERBY: {
      return {
        ...state,
        list: {
          ...state.list,
          orderBy: action.orderBy
        }
      };
    }

    default:
      return state;
  }
};

export default loadTypeReducer;
